import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ScrollToTop } from "./components/layout/ScrollToTop";
import Index from "./pages/Index";
import Services from "./pages/Services";
import Packages from "./pages/Packages";
import About from "./pages/About";
import BookACall from "./pages/BookACall";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";
import ThankYou from "./pages/ThankYou";
import BookkeepingServicesJohannesburg from "./pages/BookkeepingServicesJohannesburg";
import BookkeepingServicesCapeTown from "./pages/BookkeepingServicesCapeTown";
import BookkeepingServicesDurban from "./pages/BookkeepingServicesDurban";
import BookkeepingServicesPretoria from "./pages/BookkeepingServicesPretoria";
import InternationalServices from "./pages/InternationalServices";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/services" element={<Services />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/about" element={<About />} />
            <Route path="/book-a-call" element={<BookACall />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/bookkeeping-services-johannesburg" element={<BookkeepingServicesJohannesburg />} />
            <Route path="/bookkeeping-services-cape-town" element={<BookkeepingServicesCapeTown />} />
            <Route path="/bookkeeping-services-durban" element={<BookkeepingServicesDurban />} />
            <Route path="/bookkeeping-services-pretoria" element={<BookkeepingServicesPretoria />} />
            <Route path="/international-services" element={<InternationalServices />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
